import React from "react";
import "./portfolio1.css";
import heroImage from "../images/bbimg.jpg";

const Portfolio1 = () => {
  return (
    <div className="homepage">
      <section
        className="hero-section"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="content-overlay">
          <h1 className="portfolio-title"> Portfolio</h1>
          <div className="breadcrumb">
            Home <span className="separator"> &gt; </span>{" "}
            <span style={{ color: "yellow" }}>Portfolio</span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Portfolio1;
